import { DESTINATION_TYPES } from '../../../constants/destinationTypes';
import { Injector } from '../../../../../injector/classes/injector';
import { SSHService } from '../../../../../core/services/ssh.service';
import { NodeTypeConfigHelperConstructor } from '../../../../../connector/connector-form/helpers/node-config-helper';
import { NodeConfigHelperService } from '../../../../../connector/connector-form/helpers/node-config-helper.service';
import { DestinationTypeConfigHelper } from './destination-type-config-helper';


export class DestinationConfigHelperService extends NodeConfigHelperService {
  static deps = [
    Injector,
    SSHService
  ];

  constructor(
    protected _injector: Injector,
    private _sshService: SSHService
  ) {
    super(_injector);
  }

  getConfigHelperClass(nodeTypeIdentifier: string): NodeTypeConfigHelperConstructor {
    return DESTINATION_TYPES[nodeTypeIdentifier].configHelper;
  }

  getConfigHelperClassInstance(nodeTypeIdentifier: string): DestinationTypeConfigHelper {
    const configHelperClass = this.getConfigHelperClass(nodeTypeIdentifier);

    if ([ 'REDSHIFT', 'MYSQL', 'AURORA', 'POSTGRES', 'MS_SQL' ].includes(nodeTypeIdentifier)) {
      return new configHelperClass(nodeTypeIdentifier, this._sshService);
    }

    return new configHelperClass(nodeTypeIdentifier);
  }
}
